const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Buckingham Pi Theorem — step-by-step process ───────
function DiagramBuckinghamPi() {
  const W = 680, H = 310;
  const steps = [
    { x:40,  y:50,  w:140, label:'Step 1', sub:'List n variables', color:'#EAF3FF', stroke:'#2980b9', tc:'#2980b9' },
    { x:220, y:50,  w:140, label:'Step 2', sub:'Find m dimensions', color:'#EAF3FF', stroke:'#2980b9', tc:'#2980b9' },
    { x:400, y:50,  w:140, label:'Step 3', sub:'k = n − m groups', color:'#FEF0F0', stroke:'#c0392b', tc:'#7B0D0D' },
    { x:500, y:160, w:160, label:'Step 4', sub:'Choose m repeating\nvariables', color:'#f0fff4', stroke:'#27ae60', tc:'#27ae60' },
    { x:270, y:160, w:180, label:'Step 5', sub:'Form each π group\nby dimensional analysis', color:'#FEF0F0', stroke:'#c0392b', tc:'#7B0D0D' },
    { x:60,  y:160, w:160, label:'Step 6', sub:'Write result:\nf(π₁, π₂,…πk) = 0', color:'#FEF0F0', stroke:'#c0392b', tc:'#7B0D0D' },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Buckingham π Theorem — Six-Step Procedure</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrPI" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
        </defs>

        {/* Step boxes */}
        {steps.map(({ x, y, w, label, sub, color, stroke, tc }) => {
          const lines = sub.split('\n');
          return (
            <g key={label}>
              <rect x={x} y={y} width={w} height={lines.length > 1 ? 72 : 58} rx="8"
                fill={color} stroke={stroke} strokeWidth="1.5"/>
              <text x={x + w/2} y={y + 20} textAnchor="middle"
                fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill={tc}>{label}</text>
              {lines.map((ln, i) => (
                <text key={i} x={x + w/2} y={y + 38 + i*16} textAnchor="middle"
                  fontFamily="Courier New,monospace" fontSize="10" fill="#333">{ln}</text>
              ))}
            </g>
          );
        })}

        {/* Row 1 arrows (horizontal) */}
        <line x1="180" y1="79" x2="220" y2="79" stroke="#555" strokeWidth="1.2" markerEnd="url(#arrPI)"/>
        <line x1="360" y1="79" x2="400" y2="79" stroke="#555" strokeWidth="1.2" markerEnd="url(#arrPI)"/>

        {/* Turn down from Step 3 to Step 4 */}
        <line x1="540" y1="122" x2="540" y2="150" stroke="#555" strokeWidth="1.2"/>
        <line x1="540" y1="150" x2="580" y2="150" stroke="#555" strokeWidth="1.2"/>
        <line x1="580" y1="150" x2="580" y2="160" stroke="#555" strokeWidth="1.2" markerEnd="url(#arrPI)"/>

        {/* Row 2 arrows (right to left) */}
        <line x1="500" y1="196" x2="450" y2="196" stroke="#555" strokeWidth="1.2" markerEnd="url(#arrPI)"/>
        <line x1="270" y1="196" x2="220" y2="196" stroke="#555" strokeWidth="1.2" markerEnd="url(#arrPI)"/>

        {/* Central formula */}
        <rect x="170" y="254" width="340" height="44" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="340" y="273" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#7B0D0D">
          k = n − m  dimensionless groups
        </text>
        <text x="340" y="290" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">
          n = variables,  m = fundamental dimensions (usually 3: M, L, T)
        </text>
      </svg>
      <div style={S.dCaption}>
        The Buckingham π theorem states that any physically meaningful equation involving n variables with m fundamental
        dimensions can be rewritten as a relationship among k = n − m dimensionless groups (π terms).
        This reduces the number of independent parameters that must be studied experimentally.
      </div>
    </div>
  );
}

// ── Diagram 2: Worked Example — Drag on a Sphere ──────────────────
function DiagramDragSphere() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Worked Example — Drag Force on a Sphere in Uniform Flow</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrDS" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrDSR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Sphere with flow */}
        <circle cx="120" cy="145" r="52" fill="#e8e0d0" stroke="#7B0D0D" strokeWidth="2"/>
        {/* Streamlines */}
        {[80, 110, 145, 180, 210].map((y, i) => {
          const mid = Math.abs(y - 145);
          const gap = mid < 20 ? 66 : mid < 40 ? 58 : 54;
          return (
            <g key={y}>
              <line x1="30" y1={y} x2={120 - gap} y2={y}
                stroke="#2980b9" strokeWidth="1.2" markerEnd="url(#arrDS)" opacity="0.6"/>
              <line x1={120 + gap} y1={y} x2="210" y2={y}
                stroke="#2980b9" strokeWidth="1.2" opacity="0.6"/>
            </g>
          );
        })}
        {/* Drag force arrow */}
        <line x1="172" y1="145" x2="230" y2="145" stroke="#c0392b" strokeWidth="2.8" markerEnd="url(#arrDSR)"/>
        <text x="236" y="149" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#c0392b">F_D</text>
        {/* Velocity arrow */}
        <line x1="30" y1="250" x2="90" y2="250" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrDS)"/>
        <text x="96" y="254" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#2980b9">V</text>
        {/* Diameter */}
        <line x1="68" y1="166" x2="172" y2="166" stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="120" y="180" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#888">D</text>

        {/* Variable table */}
        <rect x="248" y="30" width="200" height="152" rx="6" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="348" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#2980b9">Variables  (n = 5)</text>
        <line x1="258" y1="58" x2="438" y2="58" stroke="#c0cedc" strokeWidth="1"/>
        {[
          {s:'F_D', d:'[MLT⁻²]'},
          {s:'V',   d:'[LT⁻¹]'},
          {s:'D',   d:'[L]'},
          {s:'ρ',   d:'[ML⁻³]'},
          {s:'μ',   d:'[ML⁻¹T⁻¹]'},
        ].map(({s, d}, i) => (
          <g key={s}>
            <text x="288" y={76 + i*22} fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#2980b9">{s}</text>
            <text x="398" y={76 + i*22} textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">{d}</text>
          </g>
        ))}

        {/* Pi groups derived */}
        <rect x="468" y="30" width="198" height="152" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="567" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">π Groups  (k = 5−3 = 2)</text>
        <line x1="478" y1="58" x2="656" y2="58" stroke="#f0cece" strokeWidth="1"/>
        <text x="478" y="78" fontFamily="Georgia,serif" fontSize="11" fill="#555">Repeating: V, D, ρ</text>
        <text x="478" y="98" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">π₁ = F_D/(ρV²D²)</text>
        <text x="478" y="114" fontFamily="Georgia,serif" fontSize="11" fill="#888">  = C_D/2  (drag coeff.)</text>
        <text x="478" y="136" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">π₂ = ρVD/μ</text>
        <text x="478" y="152" fontFamily="Georgia,serif" fontSize="11" fill="#888">  = Re  (Reynolds number)</text>

        {/* Result */}
        <rect x="248" y="196" width="418" height="78" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="457" y="218" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Result of Dimensional Analysis:</text>
        <text x="457" y="238" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#7B0D0D">C_D = f(Re)</text>
        <text x="457" y="258" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Drag coefficient depends only on Reynolds number — confirmed by experiment</text>
        <text x="457" y="274" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">5 variables → 2 dimensionless groups → 1 universal curve on a C_D–Re plot</text>
      </svg>
      <div style={S.dCaption}>
        Without dimensional analysis, studying drag on a sphere requires varying F_D, V, D, ρ, and μ independently — an enormous experimental programme.
        The π theorem reduces this to a single curve: C_D vs Re. All geometrically similar spheres at the same Re have the same C_D, regardless of size or fluid.
      </div>
    </div>
  );
}

// ── Diagram 3: The Key Dimensionless Numbers — visual map ─────────
function DiagramDimlessNumbers() {
  const W = 680, H = 310;
  const numbers = [
    { x:60,  y:50,  w:170, h:64, name:'Reynolds  Re', formula:'ρVL/μ = VL/ν', ratio:'Inertia / Viscosity', color:'#EAF3FF', stroke:'#2980b9', tc:'#2980b9' },
    { x:256, y:50,  w:170, h:64, name:'Froude  Fr',   formula:'V/√(gL)',       ratio:'Inertia / Gravity',   color:'#f0fff4', stroke:'#27ae60', tc:'#27ae60' },
    { x:452, y:50,  w:170, h:64, name:'Mach  Ma',     formula:'V/c',           ratio:'Flow / Sound speed',  color:'#FEF0F0', stroke:'#c0392b', tc:'#7B0D0D' },
    { x:60,  y:156, w:170, h:64, name:'Euler  Eu',    formula:'ΔP/(ρV²)',      ratio:'Pressure / Inertia',  color:'#fff5e6', stroke:'#e07b00', tc:'#8B4500' },
    { x:256, y:156, w:170, h:64, name:'Weber  We',    formula:'ρV²L/σ',        ratio:'Inertia / Surface tension', color:'#f5e6ff', stroke:'#8e44ad', tc:'#5b2c6f' },
    { x:452, y:156, w:170, h:64, name:'Strouhal  St', formula:'fL/V',          ratio:'Oscillation / Flow',  color:'#EAF3FF', stroke:'#2980b9', tc:'#2980b9' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Key Dimensionless Numbers in Fluid Mechanics</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {numbers.map(({ x, y, w, h, name, formula, ratio, color, stroke, tc }) => (
          <g key={name}>
            <rect x={x} y={y} width={w} height={h} rx="8" fill={color} stroke={stroke} strokeWidth="1.5"/>
            <text x={x + w/2} y={y + 18} textAnchor="middle"
              fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill={tc}>{name}</text>
            <text x={x + w/2} y={y + 36} textAnchor="middle"
              fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#1a1a2e">{formula}</text>
            <text x={x + w/2} y={y + 53} textAnchor="middle"
              fontFamily="Georgia,serif" fontSize="10" fill="#555" fontStyle="italic">{ratio}</text>
          </g>
        ))}

        {/* Additional numbers row */}
        {[
          { x:60,  name:'Cavitation  σ',  formula:'(P−Pᵥ)/(½ρV²)', color:'#FEF0F0', stroke:'#c0392b', tc:'#7B0D0D' },
          { x:256, name:'Womersley  Wo',  formula:'L√(ω/ν)',        color:'#fff5e6', stroke:'#e07b00', tc:'#8B4500' },
          { x:452, name:'Prandtl  Pr',    formula:'ν/α = μc_p/k',   color:'#f5e6ff', stroke:'#8e44ad', tc:'#5b2c6f' },
        ].map(({ x, name, formula, color, stroke, tc }) => (
          <g key={name}>
            <rect x={x} y={262} width={170} height={36} rx="8" fill={color} stroke={stroke} strokeWidth="1.2"/>
            <text x={x+85} y={276} textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill={tc}>{name}</text>
            <text x={x+85} y={291} textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#333">{formula}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Each dimensionless number represents a ratio of competing physical effects. Re governs viscous vs inertial dominance;
        Fr governs free-surface phenomena; Ma governs compressibility; We governs surface tension; Eu appears in pressure-driven flows;
        St characterises oscillating flows such as vortex shedding and pulsatile blood flow.
      </div>
    </div>
  );
}

// ── Diagram 4: Geometric, Kinematic & Dynamic Similarity ──────────
function DiagramSimilarity() {
  const W = 680, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Geometric, Kinematic &amp; Dynamic Similarity — Model vs Prototype</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrSIM" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrSIMB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrSIMR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* ── Prototype (large, left) ── */}
        <rect x="30" y="30" width="280" height="240" rx="8" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.5"/>
        <text x="170" y="54" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#2980b9">Prototype  (full scale)</text>

        {/* Ship hull shape */}
        <path d="M 60 150 Q 80 120 130 112 Q 170 108 220 112 Q 265 120 280 150 Q 270 175 170 180 Q 80 175 60 150 Z"
          fill="#8aadcc" opacity="0.35" stroke="#2980b9" strokeWidth="1.5"/>
        {/* Water line */}
        <line x1="45" y1="150" x2="300" y2="150" stroke="#2980b9" strokeWidth="1" strokeDasharray="5 3" opacity="0.7"/>
        <text x="42" y="146" textAnchor="end" fontFamily="Georgia,serif" fontSize="10" fill="#2980b9" fontStyle="italic">waterline</text>

        {/* Dimension labels */}
        <line x1="60" y1="196" x2="280" y2="196" stroke="#888" strokeWidth="1" markerEnd="url(#arrSIMB)" markerStart="url(#arrSIMB)"/>
        <text x="170" y="210" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#333">L_p = 200 m</text>
        <text x="170" y="230" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">V_p = 8 m/s,  ρ_p = 1025 kg/m³</text>
        <text x="170" y="248" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Re_p = ρ_p V_p L_p / μ_p</text>

        {/* ── Scale ratio arrow ── */}
        <line x1="318" y1="150" x2="372" y2="150" stroke="#7B0D0D" strokeWidth="2" markerEnd="url(#arrSIMR)"/>
        <rect x="310" y="126" width="60" height="50" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="340" y="146" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fontWeight="700" fill="#7B0D0D">λ = L_m/L_p</text>
        <text x="340" y="162" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#7B0D0D">= 1/50</text>

        {/* ── Model (small, right) ── */}
        <rect x="380" y="30" width="272" height="240" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="516" y="54" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Model  (1:50 scale)</text>

        {/* Smaller ship hull */}
        <path d="M 420 148 Q 432 132 460 127 Q 490 124 520 127 Q 546 132 558 148 Q 550 163 490 167 Q 432 163 420 148 Z"
          fill="#f0cece" opacity="0.45" stroke="#c0392b" strokeWidth="1.5"/>
        <line x1="404" y1="148" x2="574" y2="148" stroke="#c0392b" strokeWidth="1" strokeDasharray="5 3" opacity="0.7"/>

        {/* Dimension labels */}
        <line x1="420" y1="184" x2="558" y2="184" stroke="#888" strokeWidth="1" markerEnd="url(#arrSIMR)" markerStart="url(#arrSIMR)"/>
        <text x="490" y="198" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#333">L_m = 4 m</text>
        <text x="490" y="216" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">V_m = ? m/s</text>
        <text x="490" y="234" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Re_m = Re_p  (dynamic similarity)</text>

        {/* Similarity conditions */}
        <rect x="380" y="278" width="272" height="18" rx="4" fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x="516" y="291" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fontWeight="700" fill="#27ae60">V_m = V_p · λ^(1/2)  (Froude similarity)</text>
      </svg>
      <div style={S.dCaption}>
        A 1:50 scale ship model must satisfy similarity conditions to allow prototype predictions.
        Geometric similarity: all length ratios preserved (λ = L_m/L_p = 1/50).
        Froude similarity (free surface): V_m = V_p√λ. Reynolds similarity (viscous): Re_m = Re_p, which often conflicts with Froude similarity — requiring
        distorted models or corrections in practice.
      </div>
    </div>
  );
}

// ── Diagram 5: Reynolds Number — physical regimes map ─────────────
function DiagramReynoldsMap() {
  const W = 680, H = 280;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Reynolds Number — Flow Regime Map Across Engineering Applications</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrRM" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
        </defs>

        {/* Log-scale Re axis */}
        <line x1="40" y1="140" x2="640" y2="140" stroke="#888" strokeWidth="1.5" markerEnd="url(#arrRM)"/>
        {[
          {x:60,  label:'10⁻³'},
          {x:120, label:'10⁻¹'},
          {x:180, label:'10'},
          {x:240, label:'10³'},
          {x:300, label:'10⁴'},
          {x:360, label:'10⁵'},
          {x:420, label:'10⁶'},
          {x:480, label:'10⁷'},
          {x:540, label:'10⁸'},
          {x:600, label:'10⁹'},
        ].map(({x, label}) => (
          <g key={x}>
            <line x1={x} y1="137" x2={x} y2="143" stroke="#888" strokeWidth="1"/>
            <text x={x} y="156" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="9" fill="#666">{label}</text>
          </g>
        ))}
        <text x="650" y="144" fontFamily="Georgia,serif" fontSize="12" fill="#555">Re</text>

        {/* Regime bands */}
        {/* Stokes / creeping */}
        <rect x="40" y="100" width="160" height="36" rx="4" fill="#EAF3FF" opacity="0.8"/>
        <text x="120" y="113" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fontWeight="700" fill="#2980b9">Stokes / creeping</text>
        <text x="120" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">Re {'<'} 1</text>

        {/* Laminar */}
        <rect x="200" y="100" width="110" height="36" rx="4" fill="#f0fff4" opacity="0.9"/>
        <text x="255" y="113" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fontWeight="700" fill="#27ae60">Laminar</text>
        <text x="255" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">1 – 2300</text>

        {/* Transition */}
        <rect x="310" y="100" width="50" height="36" rx="4" fill="#fff5e6" opacity="0.9"/>
        <text x="335" y="113" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fontWeight="700" fill="#e07b00">Trans.</text>
        <text x="335" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="8" fill="#e07b00">2300–4k</text>

        {/* Turbulent */}
        <rect x="360" y="100" width="278" height="36" rx="4" fill="#FEF0F0" opacity="0.8"/>
        <text x="499" y="113" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fontWeight="700" fill="#c0392b">Turbulent</text>
        <text x="499" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#c0392b" fontStyle="italic">Re {'>'} 4000</text>

        {/* Application bubbles */}
        {[
          { x:72,  y:58, label:'Blood capillaries', sub:'Re ≈ 0.001', col:'#2980b9' },
          { x:155, y:200, label:'Lubrication film',  sub:'Re ≈ 0.1',  col:'#2980b9' },
          { x:255, y:58, label:'Pipe laminar',       sub:'Re ≈ 1000', col:'#27ae60' },
          { x:335, y:200, label:'Pipe transition',   sub:'Re ≈ 3000', col:'#e07b00' },
          { x:405, y:58, label:'Water pipe',         sub:'Re ≈ 10⁵',  col:'#c0392b' },
          { x:490, y:200, label:'Submarine',         sub:'Re ≈ 10⁷',  col:'#c0392b' },
          { x:570, y:58, label:'Large aircraft',     sub:'Re ≈ 10⁸',  col:'#c0392b' },
        ].map(({ x, y, label, sub, col }) => (
          <g key={label}>
            <rect x={x-44} y={y-18} width={88} height={32} rx="6"
              fill="white" stroke={col} strokeWidth="1.2" opacity="0.9"/>
            <text x={x} y={y-4} textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fontWeight="700" fill={col}>{label}</text>
            <text x={x} y={y+8} textAnchor="middle" fontFamily="Courier New,monospace" fontSize="8" fill="#555">{sub}</text>
            {/* Connector line to axis */}
            <line x1={x} y1={y > 140 ? y-18 : y+14} x2={x} y2={140}
              stroke={col} strokeWidth="0.8" strokeDasharray="3 2" opacity="0.6"/>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The Reynolds number spans over 12 orders of magnitude in engineering applications, from microscopic capillary blood flow (Re ≈ 0.001)
        through laminar pipe flow to turbulent flow around aircraft (Re ≈ 10⁸). The same dimensionless number governs all of these,
        making Re the single most important parameter in fluid mechanics.
      </div>
    </div>
  );
}

// ── Diagram 6: Froude Number & Free-Surface Effects ───────────────
function DiagramFroudeWeber() {
  const W = 680, H = 280;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Froude Number &amp; Weber Number — Free-Surface &amp; Surface Tension Regimes</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrFW" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
          <marker id="arrFWR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrFWB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
        </defs>

        {/* === Froude Number panel (left) === */}
        <rect x="28" y="28" width="296" height="238" rx="8" fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
        <text x="176" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#27ae60">Froude Number  Fr = V/√(gL)</text>

        {/* Sub-critical (Fr < 1) */}
        <rect x="42" y="62" width="126" height="80" rx="6" fill="white" stroke="#27ae60" strokeWidth="1"/>
        <text x="105" y="80" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#27ae60">Fr {'<'} 1</text>
        <text x="105" y="96" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">Sub-critical</text>
        <text x="105" y="110" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">(tranquil flow)</text>
        <text x="105" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">gravity dominates</text>
        <text x="105" y="138" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">disturbances travel upstream</text>

        {/* Super-critical (Fr > 1) */}
        <rect x="186" y="62" width="126" height="80" rx="6" fill="white" stroke="#c0392b" strokeWidth="1"/>
        <text x="249" y="80" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#c0392b">Fr {'>'} 1</text>
        <text x="249" y="96" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">Super-critical</text>
        <text x="249" y="110" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">(rapid flow)</text>
        <text x="249" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">inertia dominates</text>
        <text x="249" y="138" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">disturbances cannot go upstream</text>

        {/* Hydraulic jump */}
        {/* Water body */}
        <rect x="42"  y="168" width="90" height="36" rx="2" fill="#2980b9" opacity="0.30"/>
        <rect x="132" y="190" width="30" height="14" rx="2" fill="#2980b9" opacity="0.55"/>
        <rect x="162" y="186" width="112" height="18" rx="2" fill="#2980b9" opacity="0.22"/>
        <path d="M 132 168 Q 140 188 162 186" fill="none" stroke="#2980b9" strokeWidth="1.5"/>
        <text x="176" y="220" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#7B0D0D" fontStyle="italic">hydraulic jump</text>
        <text x="176" y="233" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="9" fill="#7B0D0D">Fr₁ {'>'} 1  →  Fr₂ {'<'} 1</text>
        {/* Jump arrow */}
        <line x1="100" y1="178" x2="120" y2="178" stroke="#27ae60" strokeWidth="1.5" markerEnd="url(#arrFW)"/>

        {/* Applications */}
        <text x="176" y="254" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60" fontStyle="italic">Ship waves, spillways, open-channel flow</text>

        {/* === Weber Number panel (right) === */}
        <rect x="356" y="28" width="296" height="238" rx="8" fill="#f5e6ff" stroke="#8e44ad" strokeWidth="1.5"/>
        <text x="504" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#5b2c6f">Weber Number  We = ρV²L/σ</text>

        {/* We << 1 */}
        <rect x="370" y="62" width="126" height="80" rx="6" fill="white" stroke="#8e44ad" strokeWidth="1"/>
        <text x="433" y="80" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#8e44ad">We {'<'} 1</text>
        <text x="433" y="96" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">Surface tension</text>
        <text x="433" y="110" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">dominates</text>
        <text x="433" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">droplets remain spherical</text>
        <text x="433" y="138" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">capillary flows, thin films</text>

        {/* We >> 1 */}
        <rect x="514" y="62" width="126" height="80" rx="6" fill="white" stroke="#c0392b" strokeWidth="1"/>
        <text x="577" y="80" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#c0392b">We {'>'} 1</text>
        <text x="577" y="96" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">Inertia dominates</text>
        <text x="577" y="110" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">over surface tension</text>
        <text x="577" y="126" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">droplet breakup, jet breakup</text>
        <text x="577" y="138" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#555" fontStyle="italic">sprays, atomisation</text>

        {/* Droplet / jet sketches */}
        {/* Small We — round droplet */}
        <circle cx="416" cy="192" r="20" fill="#2980b9" opacity="0.35" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="416" y="225" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#2980b9" fontStyle="italic">spherical droplet</text>
        <text x="416" y="237" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="8" fill="#8e44ad">We ≈ 0.1</text>

        {/* Large We — elongated / breaking drop */}
        <ellipse cx="578" cy="192" rx="28" ry="13" fill="#2980b9" opacity="0.25" stroke="#c0392b" strokeWidth="1.2"/>
        <path d="M 590 192 Q 610 188 622 195 Q 632 202 628 210" fill="none" stroke="#c0392b" strokeWidth="1.2" strokeDasharray="3 2"/>
        <text x="578" y="225" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#c0392b" fontStyle="italic">deforming / breaking</text>
        <text x="578" y="237" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="8" fill="#c0392b">We ≈ 10</text>

        <text x="504" y="254" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#8e44ad" fontStyle="italic">Inkjet printing, fuel sprays, rain drops</text>
      </svg>
      <div style={S.dCaption}>
        Froude number (left): governs free-surface flows. Fr {'<'} 1 (sub-critical) — gravity waves travel upstream; Fr {'>'} 1 (super-critical) — flow outruns waves.
        A hydraulic jump occurs when super-critical flow meets a barrier and transitions to sub-critical.
        Weber number (right): governs surface tension effects; We {'<'} 1 — droplets hold together; We {'>'} 1 — inertia tears them apart.
      </div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function DimensionalAnalysis() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Dimensional Analysis</h1>
      <p style={S.p}>
        Dimensional analysis is one of the most powerful tools in engineering science. It uses the
        requirement that every physically meaningful equation must be dimensionally homogeneous to reduce
        the number of independent variables in a problem, guide experimental design, and enable scale-model
        testing. The Buckingham π theorem is the formal foundation; the resulting dimensionless groups —
        Reynolds, Froude, Mach, Weber numbers — appear throughout all of fluid mechanics.
      </p>

      <InfoBox title="CORE CONCEPTS OVERVIEW" items={[
        "Dimensional homogeneity — every term in a valid physical equation must have the same dimensions",
        "Buckingham π theorem — n variables with m dimensions → k = n−m independent dimensionless groups",
        "Repeating variables method — systematic procedure for constructing π groups",
        "Reynolds number Re = ρVL/μ — ratio of inertia to viscous forces; most important number in fluid mechanics",
        "Froude number Fr = V/√(gL) — ratio of inertia to gravity; governs free-surface and open-channel flows",
        "Mach number Ma = V/c — ratio of flow speed to sound speed; governs compressibility effects",
        "Similarity — geometric, kinematic, and dynamic; required for valid model-to-prototype scaling",
      ]}/>

      {/* ── Dimensional Homogeneity ── */}
      <h2 style={S.h2}>Dimensional Homogeneity &amp; Fundamental Dimensions</h2>
      <p style={S.p}>
        The principle of dimensional homogeneity states that every term in a physically correct equation
        must have the same dimensions. This is the foundation of dimensional analysis — any equation
        that violates it is physically incorrect, regardless of numerical values.
      </p>
      <Table2 rows={[
        ["Fundamental dimensions (MLT)",
`Mass M, Length L, Time T — the three mechanical dimensions
Sometimes extended to include Temperature θ and Electric current I
Every mechanical quantity expressed as M^a L^b T^c`],
        ["Common dimensional forms",
`Velocity:       [LT⁻¹]
Acceleration:   [LT⁻²]
Force:          [MLT⁻²]
Pressure:       [ML⁻¹T⁻²]
Dynamic viscosity: [ML⁻¹T⁻¹]
Surface tension: [MT⁻²]`],
        ["Checking dimensional homogeneity",
`Example — Bernoulli: P + ½ρV² + ρgz = const
[P] = ML⁻¹T⁻² ✓
[½ρV²] = ML⁻³ · L²T⁻² = ML⁻¹T⁻² ✓
[ρgz] = ML⁻³ · LT⁻² · L = ML⁻¹T⁻² ✓   All terms equal`],
        ["Dimensionless groups",
`A dimensionless group has dimensions M⁰L⁰T⁰ = 1
Examples: Re = ρVD/μ → (ML⁻³)(LT⁻¹)(L)/(ML⁻¹T⁻¹) = M⁰L⁰T⁰ ✓
Dimensionless numbers are universal — valid in any consistent unit system`],
        ["Rayleigh method",
`Express unknown as product of variables raised to unknown powers
Apply dimensional homogeneity to each dimension (M, L, T)
Solve system of equations for exponents
Simpler than Buckingham π for single-π problems`],
      ]}/>

      {/* ── Buckingham Pi Theorem ── */}
      <h2 style={S.h2}>Buckingham π Theorem</h2>
      <p style={S.p}>
        The Buckingham π theorem formalises the reduction of variables. If a problem involves n physical
        variables expressible in m fundamental dimensions, then the relationship can always be written as
        a function of k = n − m independent dimensionless π groups.
      </p>
      <DiagramBuckinghamPi/>
      <Table2 rows={[
        ["Statement of the theorem",
`If f(Q₁, Q₂, …, Qₙ) = 0 and the Qᵢ involve m dimensions,
then g(π₁, π₂, …, πₖ) = 0 where k = n − m
The πᵢ are independent dimensionless products of the Qᵢ`],
        ["Choosing repeating variables",
`Select m variables that together contain all m dimensions
The m repeating variables must NOT form a dimensionless group among themselves
Avoid choosing the dependent variable as a repeating variable
Common choices: (V, L, ρ) or (V, D, μ) for fluid problems`],
        ["Forming π groups",
`Each π = (repeating variables)^powers × (remaining variable)
Determine powers by requiring M⁰L⁰T⁰ — set up and solve linear system
There are k = n−m non-repeating variables → k groups`],
        ["Non-uniqueness of π groups",
`π groups are not unique — any combination of π groups is also valid
π₁* = π₁/π₂ is equally valid as π₁ and π₂ separately
Choice guided by physical meaning (prefer recognised numbers)`],
        ["Completeness check",
`The k π groups must be: (1) dimensionless, (2) independent
Independence: no π group can be formed by products of the others
Rank of dimensional matrix = m (confirms k = n−m is correct)`],
      ]}/>

      {/* ── Worked Example ── */}
      <h2 style={S.h2}>Worked Example — Drag on a Sphere</h2>
      <p style={S.p}>
        The drag force on a sphere is one of the classic dimensional analysis examples. It reduces five
        physical variables to two dimensionless groups, showing that the drag coefficient is a universal
        function of Reynolds number alone for geometrically similar spheres.
      </p>
      <DiagramDragSphere/>
      <Table2 rows={[
        ["Variables and dimensions",
`F_D [MLT⁻²],  V [LT⁻¹],  D [L],  ρ [ML⁻³],  μ [ML⁻¹T⁻¹]
n = 5 variables,  m = 3 dimensions (M, L, T)
k = n − m = 2 dimensionless groups`],
        ["Repeating variables chosen",
`Choose V, D, ρ (contain L, T, M between them — all 3 dimensions)
They are independent: no combination gives M⁰L⁰T⁰
Do NOT include F_D (the dependent variable) in repeating set`],
        ["Forming π₁ (from F_D)",
`π₁ = V^a D^b ρ^c F_D
M: c + 1 = 0  →  c = −1
T: −a − 2 = 0  →  a = −2
L: a + b − 3c + 1 = 0  →  b = −2
π₁ = F_D / (ρV²D²)  →  recognised as C_D/2`],
        ["Forming π₂ (from μ)",
`π₂ = V^a D^b ρ^c μ
M: c + 1 = 0  →  c = −1
T: −a − 1 = 0  →  a = −1
L: a + b − 3c − 1 = 0  →  b = −1
π₂ = μ/(ρVD) = 1/Re  →  (or use Re = ρVD/μ)`],
        ["Physical interpretation",
`C_D = f(Re)  — confirmed by Stokes law for Re << 1: C_D = 24/Re
Sphere drag is independent of whether we use air or water, small or large sphere
as long as Re is the same. This is the power of dimensional analysis.`],
      ]}/>

      {/* ── Dimensionless Numbers ── */}
      <h2 style={S.h2}>Key Dimensionless Numbers</h2>
      <p style={S.p}>
        Each dimensionless number expresses the ratio of two competing physical effects. Identifying which
        numbers are large or small immediately tells you which physics dominates and which terms can be
        safely neglected in the governing equations.
      </p>
      <DiagramDimlessNumbers/>
      <Table2 rows={[
        ["Reynolds number Re",
`Re = ρVL/μ = VL/ν  =  Inertia / Viscous forces
Re → 0: Stokes (creeping) flow — no inertia, viscosity dominates
Re → ∞: inviscid flow — inertia dominates, thin boundary layer
Pipe: Re < 2300 laminar; Re > 4000 turbulent`],
        ["Froude number Fr",
`Fr = V/√(gL)  =  Inertia / Gravity
Fr < 1: sub-critical (tranquil) — gravity waves travel upstream
Fr > 1: super-critical (rapid) — flow outruns gravity waves
Fr = 1: critical — standing waves, minimum specific energy`],
        ["Mach number Ma",
`Ma = V/c  =  Flow speed / Speed of sound
Ma < 0.3: incompressible approximation valid (ρ error < 5%)
Ma < 1: subsonic;  Ma = 1: sonic;  Ma > 1: supersonic
Ma > 5: hypersonic — real gas effects, dissociation`],
        ["Euler number Eu",
`Eu = ΔP/(ρV²)  =  Pressure force / Inertia force
Relevant to cavitation: Eu_cav = (P − P_v)/(½ρV²) = cavitation number σ
Appears in drag and lift coefficient definitions`],
        ["Weber number We",
`We = ρV²L/σ  =  Inertia / Surface tension
We << 1: surface tension controls shape (drops, bubbles, thin films)
We >> 1: inertia dominates — jets break up, drops deform
Critical We ≈ 12 for droplet breakup (Rayleigh-Taylor)`],
        ["Strouhal number St",
`St = fL/V  =  Oscillation frequency × length / velocity
Governs periodic phenomena: vortex shedding, pulsatile flow
Kármán vortex street: St ≈ 0.2 for cylinder over wide Re range
Used to predict resonance in heat exchangers, bridge decks`],
      ]}/>

      {/* ── Reynolds Number Map ── */}
      <h2 style={S.h2}>Reynolds Number Across Applications</h2>
      <p style={S.p}>
        The Reynolds number spans more than twelve orders of magnitude in engineering and nature.
        Understanding where a specific application sits on this spectrum immediately tells you the
        appropriate analysis method and what physics to expect.
      </p>
      <DiagramReynoldsMap/>
      <Table2 rows={[
        ["Re → 0: Stokes flow",
`Drag on sphere: F_D = 3πμVD  (Stokes law — exact for Re << 1)
C_D = 24/Re;  no flow separation; streamlines symmetric fore/aft
Examples: bacteria swimming, dust particles, lubrication films
Terminal velocity: V_t = D²(ρ_s − ρ_f)g/(18μ)`],
        ["Re ~ 10–1000: intermediate",
`Oseen correction for sphere: C_D = (24/Re)(1 + 3Re/16)
Flow separates from bluff bodies; recirculation wake forms
Boundary layers thicken as Re increases
Examples: insects flying, small fish, MEMS devices`],
        ["Re ~ 10⁴–10⁶: engineering turbulent",
`Fully turbulent boundary layers; drag crisis on sphere at Re ≈ 3×10⁵
C_D for sphere drops from 0.5 to 0.1 as BL transitions to turbulent
Examples: sports balls, cars, aircraft at cruise, pipe networks`],
        ["Re > 10⁷: large-scale turbulent",
`Log-law velocity profiles well established; skin friction scales as Re⁻⁰·²
Hydraulic roughness effects become dominant
Examples: ships, submarines, large wind turbines, atmospheric flows`],
      ]}/>

      {/* ── Similarity & Model Testing ── */}
      <h2 style={S.h2}>Geometric, Kinematic &amp; Dynamic Similarity</h2>
      <p style={S.p}>
        For a physical model to give valid predictions of prototype behaviour, three levels of similarity
        must be satisfied. In practice, achieving full dynamic similarity is often impossible — requiring
        careful judgement about which dimensionless groups matter most.
      </p>
      <DiagramSimilarity/>
      <Table2 rows={[
        ["Geometric similarity",
`All length ratios preserved: L_m/L_p = λ (scale ratio) for all dimensions
Includes surface roughness: ε_m/ε_p = λ
Required for all model testing — if violated, flow patterns differ fundamentally`],
        ["Kinematic similarity",
`Velocity ratios same at all corresponding points: V_m/V_p = const
Implies same streamline pattern (geometric similarity of flow)
Requires: (V_m/V_p) = f(λ, time-scale ratio)`],
        ["Dynamic similarity",
`Force ratios same at all corresponding points
Requires matching all relevant dimensionless numbers simultaneously
In practice: choose the dominant group; apply corrections for others`],
        ["Froude scaling (free-surface flows)",
`Match Fr: V_m/V_p = √(λ)  (velocity scale = √length scale)
Time scale: t_m/t_p = √λ
Force scale: F_m/F_p = λ³ (if same fluid) or λ³ρ_m/ρ_p
Used for: ships, harbours, spillways, tidal models`],
        ["Reynolds scaling (viscosity-dominated)",
`Match Re: V_m/V_p = (ν_m/ν_p)/λ
Conflict with Froude: cannot match both Re and Fr simultaneously with same fluid
Solution: use a different fluid in the model (e.g. pressurised air → higher ρ)
Or: accept discrepancy and apply empirical correction`],
        ["Mach scaling (compressible flows)",
`Match Ma: V_m/V_p = c_m/c_p  (same Mach number)
Wind tunnel testing: match Ma; correct for Re mismatch
At transonic speeds (Ma ≈ 1): both Re and Ma must be closely matched`],
      ]}/>

      {/* ── Froude & Weber ── */}
      <h2 style={S.h2}>Froude &amp; Weber Numbers — Free Surface &amp; Surface Tension</h2>
      <p style={S.p}>
        Beyond Reynolds number, the Froude and Weber numbers govern phenomena at fluid free surfaces.
        The Froude number is essential for any flow with a liquid–gas interface — ships, rivers, spillways.
        The Weber number governs whether surface tension holds a droplet together or inertia tears it apart.
      </p>
      <DiagramFroudeWeber/>
      <Table2 rows={[
        ["Froude number applications",
`Ship resistance: F_total = F_wave(Fr) + F_friction(Re)
Model ship tested at same Fr → same wave pattern
Re mismatch corrected by friction formula
Hydraulic jump: Fr₁ > 1 → jump to Fr₂ < 1; energy dissipated`],
        ["Critical depth in open channels",
`Critical condition: Fr = 1  →  V_c = √(gA/B)  (A=area, B=water-surface width)
For rectangular channel:  y_c = (q²/g)^(1/3)  (q = Q/width)
Minimum specific energy occurs at critical depth`],
        ["Weber number applications",
`Droplet breakup: We_crit ≈ 12 (bag breakup); We ≈ 100 (stripping breakup)
Jet breakup (Rayleigh-Plateau): jet breaks if wavelength > circumference
Inkjet printing: We ≈ 10–100 to form stable droplets
Fuel atomisation: high We needed to produce fine spray droplets`],
        ["Cavitation number σ",
`σ = (P_ref − P_v)/(½ρV²)  [related to Euler number]
σ > σ_crit: no cavitation;  σ < σ_crit: cavitation
Low σ → high velocity or low pressure → cavitation onset
Propeller design: σ must exceed inception value at all operating points`],
      ]}/>

      {/* ── Summary ── */}
      <h2 style={S.h2}>Key Formulae Summary</h2>
      <InfoBox title="DIMENSIONAL ANALYSIS — QUICK REFERENCE" items={[
        "Buckingham π theorem:    k = n − m  dimensionless groups  (n variables, m dimensions)",
        "Reynolds number:         Re = ρVL/μ = VL/ν  (inertia / viscosity)",
        "Froude number:           Fr = V/√(gL)  (inertia / gravity)",
        "Mach number:             Ma = V/c  (flow / sound speed)",
        "Euler number:            Eu = ΔP/(ρV²)  (pressure / inertia)",
        "Weber number:            We = ρV²L/σ  (inertia / surface tension)",
        "Strouhal number:         St = fL/V  (oscillation / convection)",
        "Cavitation number:       σ = (P − Pᵥ)/(½ρV²)",
        "Stokes drag law (Re≪1):  F_D = 3πμVD;  C_D = 24/Re",
        "Froude scaling:          V_m/V_p = √λ  where λ = L_m/L_p",
        "Reynolds scaling:        V_m/V_p = (ν_m/ν_p)/λ",
        "Drag coefficient:        C_D = F_D/(½ρV²A)  =  f(Re, shape)",
      ]}/>
    </div>
  );
}